"use strict";

PF.Page = class Page extends PF.Widget {

    static get options() {
        return {
            rights: {},
            path: '',
        };
    }

    static get template() {
        return ``;
    }

    static collectComponent(pageClass, pageName) {
        return {
            name: pageName,
            // path: pageClass.options.path,
            ...pageClass.options,
            component: {
                render: () => pageClass.template,
                on: {
                    pageInit: function() {
                        this.page = new pageClass(this);
                    },
                    pageReinit: function() {
                        this.page.reinit();
                    },
                    pageBeforeIn: function() {
                        this.page.beforeIn();
                    },
                    pageAfterin: function() {
                        if (this.page !== undefined) {
                            this.page.afterIn();
                        }

                    },
                    pageBeforeout: function() {
                        if (this.page !== undefined) {
                            this.page.beforeOut();
                        }
                    },
                    pageBeforeremove: function() {
                        if (this.page !== undefined) {
                            this.page.beforeRemove();
                        }
                    }

                }
            },
            beforeEnter: function(routeTo, routeFrom, resolve, reject) {
                let pageClass = App.Pages[routeTo.name];
                let permissions = app.get('user.permissions', null, null);
                if (permissions == null) {
                    permissions = { 'guest': true };
                } else {
                    permissions.guest = true;
                    permissions.user = true;
                }
                for (let permission in permissions) {
                    if (permission in pageClass.options.rights) {
                        App.Pages[routeTo.name].beforeEnter(routeTo, routeFrom, resolve, reject);
                        return;
                    }
                }
                app.toast('Недостаточно прав доступа');
                reject();
                app.router.navigate('/sign-in');

            }
        };

    }

    static beforeEnter(routeTo, routeFrom, resolve, reject) {
        resolve();
    }

    constructor(f7page) {
        super({ f7page: f7page });

    }

    init(hide = false) {
        super.init();

        if (this.nameRu !== undefined) document.title = this.nameRu;

        this.dom.page = new PF.Dom.Node(this.f7page.$el[0]);
        this.dom.process(this.dom.page);

        // if (this.firstInit !== false)
        // 	{
        // this.contentTemplate = this.dom.page.children().clone();
        // }
        // this.firstInit = false;

        if (hide === true) {
            app.f7.preloader.show();
            this.dom.pageContent.css('visibility', 'hidden');
        }
    }

    show() {
        app.f7.preloader.hide();
        this.dom.pageContent.css('visibility', 'visible');
    }

    hide() {
        this.dom.pageContent.css('visibility', 'hidden');
    }


    reinit() {
        //
        // this.dom.page.empty();
        // this.dom.page.append(this.contentTemplate);
        //
        // this.contentTemplate = this.dom.page.children().clone();
        // this.dom = PF.processTemplate(this.dom.page, {page: this.dom.page});
        //
        // this.init();
    }

    beforeIn() {
        app.currentPage = this;
        this.trigger('beforeIn');
    }

    beforeOut() {
        this.trigger('beforeOut');
    }

    afterIn() {
        this.trigger('afterIn');
    }

    beforeRemove() {

    }


};